module.exports = __webpack_public_path__ + "img/dump_truck.909affe7.png";